import {
  ButtonSize,
  ButtonVariant,
  PropertyColor,
} from '@thiememeulenhoff/types';
import { customElement, property } from 'lit/decorators.js';
import { AnchorElement } from '@thiememeulenhoff/lit-sdk';
import { buttonStyles, tag } from './button.styles';

@customElement(tag)
export class ButtonComponent extends AnchorElement {
  static override styles = buttonStyles;

  @property({ type: Boolean, reflect: true })
  active = false;

  @property({ type: String, reflect: true })
  variant: ButtonVariant = 'default';

  @property({ type: String, reflect: true })
  color: PropertyColor = 'grey';

  @property({ type: String, reflect: true })
  size: ButtonSize = 'medium';
}

declare global {
  interface HTMLElementTagNameMap {
    'a-button': ButtonComponent;
  }
}
